module.exports = __webpack_public_path__ + "assets/images/C.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/C.png
// module id = 1325
// module chunks = 1